import { FeaturedIcon } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import React from 'react';

interface SettingsCardProps {
  /** Icon element rendered inside the featured icon container. */
  icon: React.JSX.Element;
  /** Card title. */
  title: string;
  /** Card description text. */
  description: string;
  /** Whether the card is in the active/selected state. */
  isActive?: boolean;
  /** Click handler for the card. */
  onClick?: () => void;
  className?: string;
}

export const SettingsCard = ({
  icon,
  title,
  description,
  isActive = false,
  onClick,
  className,
}: SettingsCardProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex items-start gap-lg rounded-sm p-md text-left transition-colors w-full',
        isActive
          ? 'bg-bg-secondary border border-fg-brand'
          : 'bg-bg-primary hover:bg-bg-secondary border border-transparent',
        className
      )}
    >
      <FeaturedIcon icon={icon} size="sm" variant="gray" />

      <div className="flex min-w-0 flex-1 flex-col gap-xxs">
        <span className="txt-small-bold text-text-primary">{title}</span>
        <span className="txt-small-regular text-text-secondary">
          {description}
        </span>
      </div>
    </button>
  );
};
